import AuthApi from './rest/AuthApi';

export default new AuthApi();
